import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=3766e424&"
import script from "./AdminTable.vue?vue&type=script&lang=js&"
export * from "./AdminTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=3766e424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports